import React, { useState, useEffect } from "react";
import Logo from "./components/Logo";
import Card from "./components/Card";
import { FaInstagram, FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import { PiAppStoreLogo } from "react-icons/pi";
import Modal from "./components/Modal";

function App() {
  const [activeModal, setActiveModal] = useState(null);

  useEffect(() => {
    // Preload images
    const images = [
      "/instagram.jpg",
      "/whatsapp.jpg",
      "/telegram.jpg",
      "/website.jpg",
      "/puma-shoes.webp",
      "/nike-shoes.webp",
    ];
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <div className="relative h-screen w-screen overflow-hidden bg-gray-900 text-gray-100">
      <main className="relative h-full w-full flex flex-col items-center justify-center px-0 pt-3 sm:px-4">
        <Logo />
        <h1 className="text-xl sm:text-3xl font-bold mt-2 sm:mt-4 mb-2 sm:mb-8 tracking-wider">
          AS.ST<span className="text-yellow-500">07</span>RE
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-1 md:gap-4 p-1 w-full max-w-4xl mb-20 flex-grow">
          <Card
            name="Instagram"
            caption={"ASTORE_KBR"}
            image="/instagram.jpg"
            color="from-pink-500 to-purple-500"
            delay={880}
            icon={<FaInstagram />}
            iconOffsetX="right-96"
            onClick={() => setActiveModal("instagram")}
          />
          <Card
            name="WhatsApp"
            caption={"AS.ST07RE"}
            image="/whatsapp.jpg"
            color="from-green-700 to-green-400"
            delay={620}
            icon={<FaWhatsapp />}
            iconOffsetX="left-96"
            onClick={() => {
              window.open("https://wa.me/+79289130013", "_blank");
            }}
          />
          <Card
            name="Telegram"
            caption={"AS.ST07RE - VAKI SHOES"}
            image="/telegram.jpg"
            color="from-blue-400 to-blue-600"
            delay={0}
            icon={<FaTelegramPlane />}
            iconOffsetX="right-96"
            onClick={() => setActiveModal("telegram")}
          />
          <Card
            name="Website"
            caption={"СКОРО"}
            image="/website.jpg"
            color="from-indigo-400 to-indigo-600"
            delay={1360}
            icon={<PiAppStoreLogo />}
            iconOffsetX="left-96"
            onClick={() => {
              // window.open("/", "_blank");
            }}
          />
        </div>

        <Modal
          isOpen={activeModal === "instagram"}
          onClose={() => setActiveModal(null)}
          topLink="https://instagram.com/astore_kbr"
          bottomLink="https://instagram.com/vaki_shoes"
        />

        <Modal
          isOpen={activeModal === "telegram"}
          onClose={() => setActiveModal(null)}
          topLink="https://t.me/as_kross"
          bottomLink="https://t.me/vaki_shoes1"
        />
      </main>
    </div>
  );
}

export default App;
